<template>
    <div>
        <resource-index
            v-if="ready"
            title="Абонементы"
            endpoint="admin/products/subscriptions"
        >
            <template slot="header-buttons">
                <router-link
                    class="btn btn-secondary"
                    :to="{
                        name: 'admin.subscriptions.create',
                    }"
                    >Создать</router-link
                >
            </template>

            <template #table-header="{ setOrder }">
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Название</th>
                    <th class="text-left p-3 px-5" scope="col">Срок</th>
                    <th
                        @click="setOrder('price')"
                        class="text-left p-3 px-5"
                        scope="col"
                    >
                        Стоимость
                    </th>
                    <th class="text-left p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:table-filters="slotProps">
                <tr class="border-b bg-gray-100">
                    <th class="p-3 px-5" scope="col">
                        <text-field
                            placeholder="Название или ID"
                            :wrap="false"
                            v-model="slotProps.filters.name"
                        />
                    </th>
                    <th class="p-3 px-5" scope="col"></th>
                    <th class="p-3 px-5" scope="col"></th>
                    <th class="p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">
                    {{ slotProps.entry.name }}
                </td>

                <td class="p-3 px-5">{{ slotProps.entry.period }} мес.</td>

                <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-success"
                        >{{ slotProps.entry.price }} ₽</span
                    >
                </td>

                <td class="p-3 px-5">
                    <router-link
                        :to="{
                            name: 'admin.subscriptions.edit',
                            params: {
                                id: slotProps.entry.id,
                            },
                        }"
                        class="btn btn-info"
                        >Изменить</router-link
                    >
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex,
    },

    data() {
        return {
            ready: !this.$route.query.category,
            title: "Абонементы",
        };
    },

    methods: {
        fetch() {
            axios.get(`/admin/products/subscriptions`).then((response) => {
                this.subscriptions = response.data.data;
            });

            this.ready = true;
        },
    },

    mounted() {
        this.fetch();
    },
};
</script>